import styled from "styled-components";
import { Text, Icon } from "../../../../services/visualLibraryService";

const RTL = "rtl";

export const ProfileItemStyled = styled.li`
  position: relative;
  display: flex;
  justify-content: center;

  &:not(:last-child) {
    margin-bottom: ${props => props.theme.components.profileSelector.spacing.xMedium};
  }
`;

export const IconStyled = styled.div`
  visibility: ${props => (props.isRowSelected ? "visible" : "hidden")};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => `${props.theme.locale.dir === RTL ? "right" : "left"}:0;
    //${props.theme.components.profileSelector.position.icon.vertical}`};
  width: ${props => props.theme.components.profileSelector.alignment.icon.edit};
  height: ${props => props.theme.components.profileSelector.alignment.icon.edit};
  padding: ${props => props.theme.components.profileSelector.spacing.small};
  border-radius: 100%;
  ${props =>
    props.isFocused
      ? `background-color: ${props.theme.components.profileSelector.colors.primary};`
      : `fill: ${props.theme.components.profileSelector.colors.white};`}
`;

export const AvatarStyled = styled.div`
  position: relative;
  width: ${props =>
    props.isFocused || props.isRowSelected
      ? props.theme.components.profileSelector.alignment.avatar.focused
      : props.theme.components.profileSelector.alignment.avatar.default};
  height: ${props =>
    props.isFocused || props.isRowSelected
      ? props.theme.components.profileSelector.alignment.avatar.focused
      : props.theme.components.profileSelector.alignment.avatar.default};
  border: ${props => `${props.theme.spacing.tiny} solid
      ${
        props.isFocused
          ? props.theme.components.profileSelector.colors.primary
          : props.showAddProfile
          ? props.theme.components.profileSelector.colors.secondary
          : "transparent"
      }`};
  border-radius: 100%;
  ${props =>
    props.isFocused &&
    `box-shadow: 0 22px 34px 0 ${`rgba(${props.theme.components.profileSelector.colors.rgb},0.5)`};`};
  ${props =>
    `margin-${props.theme.locale.dir === RTL ? "right" : "left"}: ${
      props.theme.components.profileSelector.position.icon.vertical
    }`};
`;

export const ImageStyled = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 100%;
`;

export const ProfileLogoStyled = styled.img`
  position: absolute;
  left: 0;
  width: 100%;
`;

export const ProfileNameStyled = styled.div`
  visibility: ${props => (props.isFocused ? "visible" : "hidden")};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props =>
    `${props.theme.locale.dir === RTL ? "right" : "left"}:${
      props.theme.components.profileSelector.position.text.vertical
    }`};
  display: flex;
  align-items: center;
  width: fit-content;
`;

export const TextStyled = styled(Text)`
  width: max-content;
  font-size: ${props => props.theme.components.profileSelector.typography.fontSize.default};
  font-weight: bold;
  margin-bottom: 0;
`;

export const LockIconStyled = styled(Icon)`
  pointer-events: none; 
  width: ${props => props.theme.components.profileSelector.alignment.icon.lock};
  height: ${props => props.theme.components.profileSelector.alignment.icon.lock};
  margin-${props => `${props.theme.locale.dir === RTL ? "right" : "left"}:
  ${props.theme.components.profileSelector.spacing.small}`};
  fill: ${props => props.theme.components.profileSelector.colors.white};
`;
